import { createSelector } from '@reduxjs/toolkit';
import { AdminDependenciesState, DependencyCheckStatus } from './models';
import { AdminDependenciesStore, defaultState, namespace } from './store';

const NON_FAILING: ReadonlyArray<DependencyCheckStatus> = [
  'pending',
  'pass',
  'skipped',
];

export const isFailingStatus = (status: DependencyCheckStatus) =>
  !NON_FAILING.includes(status);

export const selectStore = (state: object): AdminDependenciesState =>
  (state as Partial<AdminDependenciesStore>)[namespace] || defaultState;

export const selectDependencyResults = createSelector(
  selectStore,
  (s) => s.results
);

export const selectDependencyRunStatus = createSelector(
  selectStore,
  (s) => s.status
);

export const selectDependencyRunStartedAt = createSelector(
  selectStore,
  (s) => s.startedAt
);

/** `running` until every row resolves, then `pass` only if no row failed. */
export const selectOverallDependencyStatus = createSelector(
  selectStore,
  (s): 'running' | 'pass' | 'fail' => {
    if (s.status !== 'done') {
      return 'running';
    }
    return s.results.some((row) => isFailingStatus(row.status))
      ? 'fail'
      : 'pass';
  }
);

export const selectFailingDependencyCount = createSelector(
  selectDependencyResults,
  (results) => results.filter((row) => isFailingStatus(row.status)).length
);
